import React from 'react';
import ACardsGrid from '../../../components/ACardGrid/ACardGrid';
import { useGetPermissions } from '../../../layouts/customHook';
import {useHistory} from "react-router-dom";


const StudentTransferSetup = () => {

    const approvalConfigPermissions = useGetPermissions("transferApprovalConfig");
    const validationConfigPermissions = useGetPermissions("transferValidationConfig");
    const history = useHistory();


    const cardsInfo = [

        approvalConfigPermissions && {
            heading: 'Transfer approval config',
            subHeading: 'Master configuration for transfer approvals',
            Icon: () => null,
            onNextClick: () => history.push("/admin/studentTransferSetup/transferApprovalConfig")
        },

        validationConfigPermissions && {
            heading: 'Transfer validations config',
            subHeading: 'Master configuration for transfer validations',
            Icon: () => null,
            onNextClick: () => history.push("/admin/studentTransferSetup/transferValidationsConfig")
        }
    ]

    return (
        <ACardsGrid cardsInfo={cardsInfo} />
    );
}

export default StudentTransferSetup;